import { fetchWithAuth } from './utils';

export async function createGroup(values) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/groups/create`);

    const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(values)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }
    
    return await response.json();
}